export default __webpack_public_path__ + "static/media/IFSEC-LONDON.a4406298.jpg";